import { BorderConfig } from './border-config.model';

export const borderConfigToStyle = (border: BorderConfig) => {
    return `${border.size ?? '1px'} ${border.style ?? 'solid'} ${border.color}`;
};
